import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import {
  getAllLsBets,
  getBetslipType,
  getEditBet
} from 'store/selectors/betslip';
import { getPartnerConfigs } from 'store/selectors/socket';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

export const useSuperBetAvailable = () => {
  const partnerConfigs = useSelector(getPartnerConfigs);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const user = useSelector(getUser);
  const betslipType = useSelector(getBetslipType);
  const allLsBets = useSelector(getAllLsBets);
  const editBet = useSelector(getEditBet);

  if (
    !isLoggedIn ||
    !allLsBets?.length ||
    !partnerConfigs ||
    betslipType === 1 ||
    editBet?.active ||
    SpringConfigs.SUPER_BET_DEFAULT_ON
  ) {
    return false;
  }

  return (
    user.is_super_bet_available &&
    !allLsBets.some(
      ({ isLive, game_info }) =>
        (isLive
          ? !partnerConfigs.is_superbet_on_live
          : !partnerConfigs.is_superbet_on_prematch) ||
        (game_info &&
          Object.prototype.hasOwnProperty.call(game_info, 'virtual'))
    )
  );
};
